import { createTestId } from 'utils';
import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from 'configuration/app-context';
import * as Icon from 'react-feather';
import { NotificationService } from 'utils/api-service';
import OneSignalReact from 'react-onesignal';
import { useSelector } from 'react-redux';
import IBigSpinner from 'components/spinner/big-spinner';
import WebClient from 'utils/webclient'

const OneSignalCustomLinkContainer = () => {
    useEffect(() => {
        // console.log({ wOS: window?.OneSignal, os: OneSignalReact });
        window?.OneSignal?.eventHelper?.onSubscriptionChanged_updateCustomLink();
    }, []);
    return <div className='onesignal-customlink-container text-center' />;
};

const Notifications = () => {
    const { translate, dateFormat, showDialog, toastSuccess } = useContext(AppContext);
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const common = useSelector((state) => state.common);

    function deleteNotification(ids = [], deleteAll = false) {
        let c = new WebClient();
        c.post("5A3D76B839D1770F9281663E/Delete", { 
            notificationIds: ids,
            deleteAll: deleteAll 
        }, true, false, false)
            .then(({ isSuccess, exception, data }) => {
                if (isSuccess) {
                    if(deleteAll){
                        toastSuccess(translate("notifications_deleted")) 
                        setNotifications([])  
                    } else {
                        toastSuccess(translate("notification_deleted"))   
                    }               
                }
            })
    }


    function markAsRead(ids, markAsReadAll = false) {
        let c = new WebClient();
        c.post("/5A3D76B839D1770F9281663E/Read", { 
            notificationIds: ids, 
            markAsReadAll: markAsReadAll
        }, true, false, false)
            .then(({ isSuccess, exception, data }) => {
                if (isSuccess) {
                    markAsReadAll ?  toastSuccess(translate("all_notifications_marked_as_read"))  
                        : toastSuccess(translate("notification_marked_as_read"))   
                    getNotificationList()
                }
            })
    }

    const getNotificationList = async () => {
        setLoading(true);
        const { isSuccess, exception, data } = await new NotificationService().listNotifications({});
        if (isSuccess) {
            setNotifications(data);
        } else {
            setNotifications([]);
        }
        setLoading(false);
    }

    useEffect(() => {
        setLoading(true);
        (async () => {
            let playerId = '';
            if (common.notificationState !== 'unsupported') {
                // unsupported ise OneSignalReact.getUserId() calışmıyor. Alt satıra geçmiyor.
                playerId = (await OneSignalReact.getUserId()) || '';
            }
            getNotificationList()
        })();
    }, [common.notificationState]);

    return (
        <>
            {loading ? (
                <div className='w-full flex items-center justify-center h-64'>
                    <IBigSpinner size='sm' />
                </div>
            ) : (
                <>
                    {notifications.length == 0 ? (
                        <div className='card w-80 mx-auto space-y-4'>
                            <div className='card-body text-center space-y-2'>
                                <div className='icon mb-4'>
                                    <Icon.Bell size={72} />
                                </div>
                                <h6 className="text-xl text-neutral-600 text-center">{translate('no_notification')}</h6>
                            </div>
                        </div>
                    ) : (
                        <>
                        <div className='flex items-center justify-end gap-4 text-xs font-medium mb-4'>
                            {
                                notifications.filter(item => item.status == 1).length > 0 && (
                                    <button className='flex items-center gap-1 text-gray-700'
                                    data-testid={createTestId('button', 'Notifications', 1)}
                                    onClick={() => {
                                        showDialog(
                                            translate('are_you_sure'),
                                            translate('all_notifications_will_be_marked_as_read'),
                                            'warning',
                                            true,
                                            translate('yes'),
                                            translate('no'),
                                            () => {
                                                markAsRead([], true)
                                            },
                                            () => {

                                            }
                                        )}}>
                                        <Icon.Check size={12} />
                                        {translate("mark_as_all_read")}
                                    </button>
                                )
                            }
                            {
                                notifications.length > 0 && (
                                    <button className='flex items-center gap-1 text-danger'
                                        data-testid={createTestId('button', 'Notifications', 2)}
                                        onClick={() => {
                                            showDialog(
                                                translate('are_you_sure'),
                                                translate('all_notifications_will_delete'),
                                                'warning',
                                                true,
                                                translate('yes'),
                                                translate('no'),
                                                () => {
                                                    deleteNotification([], true)
                                                },
                                                () => {

                                                }
                                            )}}>
                                        <Icon.Trash2 size={12} />
                                        {translate("delete_all")}
                                    </button>
                                )
                            }
                        </div>
                        <ul className='notification-list'>
                            {notifications.map((item, index) => {
                                return (
                                    <li key={index} className='notification'>
                                        {
                                            item.status == 1 && (
                                                <div className='badge'></div>
                                            )
                                        }
                                        <div className='body'>
                                            {item?.title && (
                                            <div className='flex items-center justify-between'>
                                                <h5 className='active text-sm font-semibold text-primary-800'>
                                                    {item?.title}
                                                </h5>
                                                <div className="trigger relative !w-auto !h-auto">
                                                    <Icon.MoreHorizontal className="trigger-icon !block w-auto h-auto !text-gray-400 hover:bg-none"/>
                                                    <div className="dropdown !left-[-180px] text-xs">
                                                        {
                                                            item.status == 1 && (
                                                                <button className="item"  data-testid={createTestId('button', 'Notifications', 3)} onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    showDialog(
                                                                        translate('are_you_sure'),
                                                                        translate('notification_will_be_marked_as_read'),
                                                                        'warning',
                                                                        true,
                                                                        translate('yes'),
                                                                        translate('no'),
                                                                        () => {
                                                                            markAsRead([item.id])
                                                                        },
                                                                        () => {
        
                                                                        }
                                                                    );
                                                                }}>
                                                                    <Icon.Check size={12}/>
                                                                    {translate("mark_as_read")}
                                                                </button>
                                                            )
                                                        }
                                                        <button className="item"  data-testid={createTestId('button', 'Notifications', 4)} onClick={(event) => {
                                                            event.stopPropagation();
                                                            showDialog(
                                                                translate('are_you_sure'),
                                                                translate('notification_will_delete'),
                                                                'warning',
                                                                true,
                                                                translate('yes'),
                                                                translate('no'),
                                                                () => {
                                                                    deleteNotification([item.id])

                                                                    const newData = notifications.filter((a) => a.id !== item.id);
                                                                    if (newData) {
                                                                        setNotifications(newData);
                                                                    }
                                                                },
                                                                () => {

                                                                }
                                                            );
                                                        }}>
                                                            <Icon.Trash2 size={12}/>
                                                            {translate("delete")}
                                                        </button>
                                                    </div>
                                                </div>
                                             </div>
                                            )}
                                            <p>{item?.description}</p>
                                            <small className='text-xs text-gray-300'>
                                                {dateFormat(item?.sentDate, 'DD MMMM yyyy')}
                                            </small>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default Notifications;
